var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,7.545V1H18.455V3.182H7.545V1H1V7.545H3.182V18.455H1V25H7.545V22.818H18.455V25H25V18.455H22.818V7.545ZM3.182,3.182H5.364V5.364H3.182ZM5.364,22.818H3.182V20.636H5.364Zm13.091-2.182H7.545V18.455H5.364V7.545H7.545V5.364H18.455V7.545h2.182V18.455H18.455Zm4.364,2.182H20.636V20.636h2.182ZM20.636,5.364V3.182h2.182V5.364Zm-5.749,9.818H11.08l-.8,2.182H8.516l3.709-9.818h1.527l3.72,9.818H15.695l-.807-2.182Zm-3.316-1.375h2.847L13,9.629l-1.429,4.178Z",
    transform: "translate(-1 -1)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextArea);
export default __webpack_public_path__ + "static/media/text_area.dcef5f7f60e9d6167f67d15ae69734bd.svg";
export { ForwardRef as ReactComponent };